import { render, staticRenderFns } from "./ModalConsignmentShowWeightDirty.vue?vue&type=template&id=084ef259&"
import script from "./ModalConsignmentShowWeightDirty.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentShowWeightDirty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports